import http from '../http/common'

const resource = '/send-sms'

export default {

	send: (payload) => http.post(`${resource}`, payload),
}
